import React, { useState } from 'react'
import { PolicyListCard } from '../PolicyListCard'
import { Grid } from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { NoPoliciesCard } from '../NoPoliciesCard'
import NewFillButton from '../../Core/NewFillButton'
import { isMobile } from 'react-device-detect'
import DownloadBannerWeb from '../../DownloadAppBanner/PolicyManagementDownloadBanner/DownloadBannerWeb'
import DownloadBannerForMobile from '../../DownloadAppBanner/DownloadBannerForMobile'

export const ActivePoliciesList = ({ policies, selectable = false, onPolicySelect }) => {
  const [isShowDownloadBannerInPoicy, setIsShowDownloadBannerInPoicy] = useState(true)
  const matches = useMediaQuery('(min-width:1150px)')
  const small = matches && policies.length > 1
  return (
    <Grid container spacing={4}>
      <Grid xs={12} lg={9}>
        {policies.length > 0 && (
          <Grid item={policies[0]}>
            <PolicyListCard
              buttons={
                selectable ? (
                  <NewFillButton green onClick={() => onPolicySelect(policies[0], 0)}>
                    Choose this policy
                  </NewFillButton>
                ) : undefined
              }
              selectable={selectable}
              small={small}
              key={0}
              insurance={policies[0]}
            />
          </Grid>
        )}
      </Grid>
      {!isMobile && isShowDownloadBannerInPoicy && (
        <Grid xs={12} lg={3} item className="policy-grid">
          <DownloadBannerWeb />
        </Grid>
      )}
      <Grid xs={12} lg={9}>
        {policies.length > 0 &&
          policies.map((item, index) =>
            index > 0 ? (
              <>
                <Grid item>
                  <PolicyListCard
                    buttons={
                      selectable ? (
                        <NewFillButton green onClick={() => onPolicySelect(item, index)}>
                          Choose this policy
                        </NewFillButton>
                      ) : undefined
                    }
                    selectable={selectable}
                    small={small}
                    key={index}
                    insurance={item}
                  />
                </Grid>
              </>
            ) : null
          )}
      </Grid>
      <Grid xs={12} lg={3} item className="policy-grid">
        {isMobile ? (
          <DownloadBannerForMobile
            headerText1="Available right in your pocket!"
            headerText2="Download our new app"
            containerClassName="cng-mobile-bg-image policy-management-banner"
            androidURL="https://voominsurancpro.page.link/?link=https://play.google.com/store/apps/details?id%3Dcom.voom_motorcycle_app&apn=com.voom_motorcycle_app&utm_campaign=policy_management&utm_medium=banner&utm_source=google"
            iosURL="https://voominsurancpro.page.link/?link=https://apps.apple.com/us/app/voom-motorcycle-insurance/id1641498413&isi=1641498413&ibi=com.voominsurance.motorcycles&utm_campaign=policy_management&utm_medium=banner&utm_source=voom"
          />
        ) : (
          ''
        )}
      </Grid>
      {policies.length == 0 && (
        <Grid xs={12} item>
          <NoPoliciesCard />
        </Grid>
      )}
    </Grid>
  )
}
